import {Context, provide} from "@acng/frontend-relativity";

/**
 * @type {import("@acng/frontend-relativity").ObservableType<?import("../types").Timing>}
 */
export const ctxTiming = Context();
